export const MAX_LENGTHS = {
  displayName: 50,
  description: 512,
  address: 256,
  email: 128,
  website: 256,
};

export const VALIDATION_RULES = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  website: /^https?:\/\/.+/,
};

export const FILE_CONSTRAINTS = {
  maxSize: 5 * 1024 * 1024, // 5MB
  allowedTypes: ['image/png', 'image/jpeg'],
};